export default function getImageDimensionsFromFile(
    file: File,
    callback: (width: number, height: number) => void
) {
    const reader = new FileReader();
    reader.onload = function() {
        const img = new Image();
        img.onload = function() {
            callback(img.width, img.height);
        };
        img.onerror = function() {
            // If error, return 0 * 0 dimensions.
            callback(0, 0);
        };
        img.src = reader.result as string;
    };
    reader.readAsDataURL(file);
}
